<template>
  <Visitor>
    <div class="bg-gray-100 min-h-screen">
      <main class>
        <div class="max-w-2xl mx-auto py-8 sm:px-6 lg:px-8">
          <div class="bg-white rounded-lg shadow px-5 py-6 sm:px-6 mx-2">
            <h2
              class="text-2xl font-bold leading-none text-gray-900 sm:text-3xl sm:truncate"
            >Analizar Costo</h2>
            <p class="my-4 font-semibold">Opciones de este servicio</p>
            <div class="sm:flex items-start">
              <div class="flex items-center">
                <input
                  id="only_workforce"
                  name="form-input kind"
                  type="radio"
                  class="form-radio h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                  :value="false"
                  v-model="includeMaterials"
                />
                <label for="only_workforce" class="ml-3">
                  <span class="block text-sm leading-5 font-medium text-gray-700">Solo mano de obra</span>
                </label>
              </div>
              <div>
                <div class="flex items-center sm:ml-8 mt-4 sm:mt-0">
                  <input
                    id="include_materials"
                    name="form-input kind"
                    type="radio"
                    class="form-radio h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                    :value="true"
                    v-model="includeMaterials"
                  />
                  <label for="include_materials" class="ml-3">
                    <span
                      class="block text-sm leading-5 font-medium text-gray-700"
                    >Mano de obra y materiales</span>
                  </label>
                </div>
                <div
                  :class="includeMaterials ? 'grid' : 'hidden'"
                  class="mt-4 ml-0 sm:ml-8 grid-cols-2 col-gap-8 row-gap-2"
                >
                  <div class="flex items-start col-span-1">
                    <div class="absolute flex items-center h-5">
                      <input
                        id="material_1"
                        type="checkbox"
                        class="form-checkbox h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div class="pl-7 text-sm leading-5">
                      <label for="material_1" class="font-medium text-gray-700">Material 1</label>
                    </div>
                  </div>
                  <div class="flex items-start col-span-1">
                    <div class="absolute flex items-center h-5">
                      <input
                        id="material_2"
                        type="checkbox"
                        class="form-checkbox h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div class="pl-7 text-sm leading-5">
                      <label for="material_2" class="font-medium text-gray-700">Material 2</label>
                    </div>
                  </div>
                  <div class="flex items-start col-span-1">
                    <div class="absolute flex items-center h-5">
                      <input
                        id="material_3"
                        type="checkbox"
                        class="form-checkbox h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div class="pl-7 text-sm leading-5">
                      <label for="material_3" class="font-medium text-gray-700">Material 3</label>
                    </div>
                  </div>
                  <div class="flex items-start col-span-1">
                    <div class="absolute flex items-center h-5">
                      <input
                        id="material_4"
                        type="checkbox"
                        class="form-checkbox h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div class="pl-7 text-sm leading-5">
                      <label for="material_4" class="font-medium text-gray-700">Material 4</label>
                    </div>
                  </div>
                  <div class="flex items-start col-span-1">
                    <div class="absolute flex items-center h-5">
                      <input
                        id="material_5"
                        type="checkbox"
                        class="form-checkbox h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div class="pl-7 text-sm leading-5">
                      <label for="material_5" class="font-medium text-gray-700">Material 5</label>
                    </div>
                  </div>
                  <div class="flex items-start col-span-1">
                    <div class="absolute flex items-center h-5">
                      <input
                        id="material_6"
                        type="checkbox"
                        class="form-checkbox h-4 w-4 text-primary-600 transition duration-150 ease-in-out"
                      />
                    </div>
                    <div class="pl-7 text-sm leading-5">
                      <label for="material_6" class="font-medium text-gray-700">Material 6</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mx-auto text-center mt-6">
              <router-link
                class="inline-flex rounded-md shadow-sm sm:ml-2"
                :to="'/service/'+this.$route.params.serviceId+'/form'"
              >
                <button
                  type="button"
                  class="inline-flex items-center px-3 py-2 mx-3 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                >Contratar servicio</button>
              </router-link>

              <router-link class="inline-flex rounded-md shadow-sm sm:ml-8 mt-2 sm:mt-0" to="#">
                <button
                  type="button"
                  class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition ease-in-out duration-150"
                >Detalles de cotización</button>
              </router-link>
            </div>
          </div>
        </div>
      </main>
    </div>
  </Visitor>
</template>

<script>
import Visitor from "../Layouts/Visitor";

export default {
  name: "ServiceCost",
  components: {
    Visitor,
  },
  data() {
    return {
      includeMaterials: true,
    };
  },
};
</script>